import { Injectable } from '@angular/core';
import { getPrivileges, NavigationItemWithVisibility } from './privileges';

@Injectable({
    providedIn: 'root',
})
export class UrlPrivilegeUtilService {
    // Returns only visible URL privileges
    public getVisibleURLPrivileges(): NavigationItemWithVisibility[] {
        return this._getPrivileges().filter((urlPrivilege: NavigationItemWithVisibility) => urlPrivilege.visible);
    }

    // Returns all URL privileges regardless of visibility
    public getAllURLPrivileges(): NavigationItemWithVisibility[] {
        return this._getPrivileges();
    }

    // Returns basic user urls
    public getUserBasicUrls(): string[] {
        return ['', '/', 'reset-password', 'notifications-settings', 'account', 'account/:tab', 'notification-history'];
    }

    private _getPrivileges(): NavigationItemWithVisibility[] {
        return getPrivileges();
    }
}
